<template>
    <ul class="productlists">
        <li
            v-for="productlist of productlists"
            @click="$router.push('/productlistdetails/' + productlist.nr)">
            {{ productlist.nr }} - {{ productlist.label }}
        </li>

        <li
            v-if="product.partslistId"
            @click="
                $router.push(
                    '/partslistview/' +
                        product.productId +
                        '/' +
                        product.partslistId
                )
            ">
            {{ product.partslistId }} - Stuklijst
        </li>

        <li
            v-for="optimizedpaintlist in product.optimizedpaintlistIds"
            :key="optimizedpaintlist.ID"
            @click="
                $router.push('/optimizedpaintlistview/' + optimizedpaintlist.ID)
            ">
            {{ optimizedpaintlist.ID }} - Lakbon
        </li>

        <li
            v-for="pleatinglist in product.pleatinglists"
            :key="pleatinglist.id"
            @click="
                $router.push('/pleatinglistdetails/' + pleatinglist.id)
            ">
            {{ pleatinglist.nr }} - Plooibon
        </li>
    </ul>
</template>

<script>
import productListApi from '../../api/productList';
import { showErrorMessage } from '../../dialogs';

export default {
    props: {
        product: Object,
    },
    data() {
        return {
            productlists: [],
        };
    },
    mounted() {
        productListApi
            .listProductListsByProduct(this.product.productId)
            .then((response) => {
                this.productlists = response.data;
            })
            .catch(() => {
                showErrorMessage('Bonnen konden niet geladen worden.');
            });
    },
};
</script>

<style scoped lang="scss">
ul {
    padding-left: 20px;

    li {
        cursor: pointer;

        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 18px;
        color: gray;
        text-decoration: underline;
    }
}
</style>
